import { useSoftDeployAccess } from './featureHelper';

const usePlaybooksAccess = (): boolean => useSoftDeployAccess('AGENT_PLAYBOOKS');

export default usePlaybooksAccess;
